export default "__VITE_ASSET__D2qn0F2D__"